module.exports = __webpack_public_path__ + "img/2020_09_dande_singapore_fin_web.35fb80d3.jpg";